import * as Error from '../../utils/error';
import * as SettingsErrors from '../../errors/settings';

export const getSettings = (state) => state.settings || {};

export const isCollaborationAsked = (state = {}) => {
    const { withCollaboration } = getSettings(state);

    return !!withCollaboration;
};

export const isPreRevisionBehavior = (state) => {
    const { withPreRevision } = getSettings(state);
    return !!withPreRevision;
};

export const isRevisionBehavior = (state = {}) => {
    const { withRevision } = getSettings(state);
    return !!withRevision;
};

export const isPostRevisionBehavior = (state = {}) => {
    const { withPostRevision } = getSettings(state);

    return !!withPostRevision;
};

export const isModalBehavior = (state = {}) => {
    const { withModalBehavior } = getSettings(state);

    return !!withModalBehavior;
};

export const isStandaloneBehavior = (state = {}) =>
    !isModalBehavior(state);

export const getSource = (state = {}) =>
    getSettings(state).source;

export const getWithUnsubscribe = (state = {}) =>
    !!getSettings(state).withUnsubscribe;

export const getContextId = (state = {}) => {
    try {
        const { contextId } = getSettings(state);

        if (!contextId) {
            throw Error.create(
                `ContextId is falsy: ${contextId}`,
                SettingsErrors.SETTINGS_SELECTORS_GET_CONTEXT_ID_FALSY
            );
        }

        return contextId;
    } catch (error) {
        if (!error.code) {
            error.code = SettingsErrors.SETTINGS_SELECTORS_GET_CONTEXT_ID_UNEXPECTED;
        }

        throw error;
    }
};

export const getContextType = (state = {}) => {
    try {
        const { contextType } = getSettings(state);

        if (!contextType) {
            throw Error.create(
                `ContextType is falsy: ${contextType}`,
                SettingsErrors.SETTINGS_SELECTORS_GET_CONTEXT_TYPE_FALSY
            );
        }

        return contextType;
    } catch (error) {
        if (!error.code) {
            error.code = SettingsErrors.SETTINGS_SELECTORS_GET_CONTEXT_TYPE_UNEXPECTED;
        }

        throw error;
    }
};

export const getRequiredGroupType = (state) => getSettings(state).requiredGroupType;

export const isTeamCollaboration = (state) => !!getSettings(state).teamId;
export const eligibleForPdfViewer = (state) => getSettings(state).showPdfViewer;
